import { Vue, Options } from 'vue-class-component';
import Step1 from './Step1/Step1.vue';
import Step2 from './Step2/Step2.vue';
import Step3 from './Step3/Step3.vue';
import Step4 from './Step4/Step4.vue';
import {
  AddRoomObjectDTO,
  EditRoomObjectDTO,
  IEditRoomObjectDTO,
  IRoomObjectDTO,
} from '@/../client-generator/generated-clients/plants';
import plantsClient from '@/core/services/plants';
import { SET_APP_LOADING } from '@/core/store/action-types';
import {
  AUTOMATION_WIZARD_NEXT_CALLED,
  HANDLE_REFRESH_PLANT,
} from '@/core/utils/emitter-events';
import { DefaultDevicesSettingsDTO } from '@/../client-generator/generated-clients/device-settings';
import DeviceSettingsService from '@/core/services/device-settings-services/device-settings-service';
import { NamingService } from '../../../../../core/services/naming.service';

@Options({
  name: 'AutomationWizard',
  components: {
    Step1,
    Step2,
    Step3,
    Step4,
  },
})
export default class AutomationWizard extends Vue {
  activeStep = 0;
  roomObject: IRoomObjectDTO = {};
  devicesSettings: DefaultDevicesSettingsDTO[] = [];
  plantId = -1;
  roomId = '';
  roomName = '';
  roomType = '';
  roomObjectId = '';
  nextDisabled = false;

  steps = [
    {
      title: 'AppResource.NameAndProperties',
    },
    {
      title: 'AppResource.AssignTheActuator',
    },
    {
      title: 'AppResource.AssignTheCommands',
    },
    {
      title: 'AppResource.EndTheConfiguration',
    },
  ];

  get currentStepTitle() {
    return this.$t(this.steps[this.activeStep].title);
  }

  get buttonSubmitLabel() {
    if (this.activeStep < this.steps.length - 1) {
      return this.$t('AppResource.Next');
    }

    return this.$t('AppResource.SaveAndExit');
  }

  get activeStepComponent() {
    return `Step${this.activeStep + 1}`;
  }

  created() {
    this.plantId = +this.$route.params.plantId;
    this.roomId = this.$route.params.roomId as string;
    this.roomObjectId = this.$route.params.roomObjectId as string;

    this.roomName = this.$route.query.roomName as string;
    this.roomType = this.$route.query.roomType as string;

    this.fetchRoomObject();
  }

  async fetchRoomObject() {
    this.$store.dispatch(SET_APP_LOADING, true);
    this.roomObject = await plantsClient.roomObjectsGET(
      this.plantId,
      this.roomId,
      this.roomObjectId
    );
    this.$store.dispatch(SET_APP_LOADING, false);
  }

  async handleButtonSubmitAction() {
    this.$emitter.emit(AUTOMATION_WIZARD_NEXT_CALLED);
    if (this.activeStep < this.steps.length - 1) {
      this.activeStep++;
      return;
    }

    this.$store.dispatch(SET_APP_LOADING, true);

    const dto: IEditRoomObjectDTO = {
      deviceSettings: DeviceSettingsService.generateDeviceSettingsResultDto(
        this.devicesSettings
      ),
      roomObject: AddRoomObjectDTO.fromJS(this.roomObject),
    };

    try {
      await plantsClient.roomObjectsPUT(
        this.plantId,
        this.roomId,
        this.roomObjectId,
        new EditRoomObjectDTO(dto)
      );

      this.$router.push({
        name: 'page-plant-room',
        query: { refresh: 'true' },
      });
    } catch (error) {
      let messageError = '';
      console.log(error);
      switch (error.status) {
        case 409:
          this.$emitter.emit(HANDLE_REFRESH_PLANT);
          this.$router.push({
            name: 'page-plant-dashboard',
            params: this.$route.params,
          });
          break;
        default:
          messageError = this.$t('apiErrors.serverError').toString();
      }

      if (messageError) {
        this.$toast.add({
          severity: 'error',
          summary: this.$t('general.operationError'),
          closable: true,
          life: 3000,
        });
      }
    } finally {
      NamingService.flushCache();
      this.$store.dispatch(SET_APP_LOADING, false);
    }
  }

  handleButtonBackAction() {
    if (this.activeStep > 0) {
      this.nextDisabled = false;
      this.activeStep--;
    } else {
      this.$router.push({ name: 'page-plant-room' });
    }
  }

  nextEnabledEvent(nextEnabled: boolean) {
    this.nextDisabled = !nextEnabled;
  }
}
